module.exports = __webpack_public_path__ + "media/images/subject_img/DIGITAL ART-54b23c5057cf0b0737724ef150c02d9d.jpg";